const dropZone = document.getElementsByClassName('fileinput');
const inputFile = document.getElementsByClassName('fileinput__input');
const deleteFile = document.getElementsByClassName('fileinput__controls-item_delete');

for (let i = 0; i < dropZone.length; i++) {
    dropZone[i].addEventListener('dragover', function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.classList.add('fileinput_drag');
    }, true);

    dropZone[i].addEventListener('drop', function () {
        this.classList.remove('fileinput_drag');
    }, true);

    deleteFile[i].addEventListener('click', function () {
        clearFile(this);
        $(dropZone[i]).trigger('cleared.fileinput.eksmo');
    }, true);

    inputFile[i].addEventListener('change', function (e) {
        if (e.target.files[0]) {
            this.closest('.fileinput').classList.add('fileinput_filled');
            this.previousElementSibling.previousElementSibling.innerHTML = e.target.files[0].name;
            $(dropZone[i]).trigger('filled.fileinput.eksmo');
        } else {
            this.closest('.fileinput').classList.remove('fileinput_filled');
            this.previousElementSibling.previousElementSibling.innerHTML = 'Перетащите файл с компьютера в эту область';
            $(dropZone[i]).trigger('cleared.fileinput.eksmo');
        }
    }, true);
}

$(dropZone).on('clear.fileinput.eksmo', function () {
    clearFile(this.getElementsByClassName('fileinput__controls-item_delete')[0]);
});

function clearFile(el) {
    el.parentNode.nextElementSibling.value = '';
    el.closest('.fileinput').classList.remove('fileinput_filled');
    el.parentNode.previousElementSibling.innerHTML = 'Перетащите файл с компьютера в эту область';
}